import { render, staticRenderFns } from "./gc-popup-account-status-modal.vue?vue&type=template&id=277e2940&"
import script from "./gc-popup-account-status-modal.vue?vue&type=script&lang=js&"
export * from "./gc-popup-account-status-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports